// src/jsx/pages/users/UserForm.js
import { Button, Form, Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { getCompanies } from '../../../lib/getCompanies';

const { Option } = Select;

const UserForm = ({ user, onSubmit }) => {
  const [form] = Form.useForm();
  const [companies, setCompanies] = useState([]);
  
  useEffect(() => {
    getCompanies().then(res => setCompanies(res.data));
  }, []);
  const handleFinish = (values) => {
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={user || { role: 'admin', status: 'ACTIVE' }}
      onFinish={handleFinish}
    >
      <Form.Item
        name="name"
        label="Nombre"
        rules={[{ required: true, message: 'Ingrese un nombre' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="email"
        label="Email"
        rules={[{ required: true, type: 'email', message: 'Ingrese un email válido' }]}
      >
        <Input />
      </Form.Item>

      
        <Form.Item
          name="password"
          label="Contraseña"
          initialValue={user ? user.passsword : ''}
          rules={[{ required: true, message: 'Ingrese una contraseña' }]}
        >
          <Input.Password />
        </Form.Item>
      

      {/* Campo oculto para el rol, siempre con valor 'empresa' */}
      <Form.Item name="role" initialValue="admin" style={{ display: 'none' }}>
        <Input type="hidden" />
      </Form.Item>
      {/* 
        If user exists, select the company with the same companyId as user.companyId.
        This is achieved by setting the default value of the Select to user.companyId.
      */}
      <Form.Item
        name="companyId"
        label="Empresa"
        rules={[{ required: true }]}
        initialValue={user ? user.company._id : undefined}
      >
        <Select disabled={!!user}>
          {companies.map((company) => (
            <Select.Option value={company._id} key={company._id}>
              {company.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name="status" label="Estado">
        <Select>
          <Option value="ACTIVE">Activo</Option>
          <Option value="INACTIVE">Inactivo</Option>
        </Select>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" block>
          Guardar
        </Button>
      </Form.Item>
    {/* Hidden field for user._id, used for editing existing users */}
    <Form.Item name="_id" initialValue={user ? user._id : undefined} style={{ display: 'none' }}>
      <Input type="hidden" />
    </Form.Item>
    </Form>
  );
};

export default UserForm;
